import React, { useState, useEffect } from "react";
import { createContext } from "react";
import axios from "axios";
import { calculateDistance } from "../../../utils/service";
import ContentData from "../../../constants/contentFile.json";
import { gateInOut, getIntentDetails } from "../../../apis/Api";
import RouteConstant from "../../../constants/routesContent.json";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { useCookies } from "react-cookie";

export const GateInContext = createContext({});
export const GateInContextProvider = ({ children }) => {
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [imageErrorMsg, setImageErrorMsg] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);
  const [captureDate, setCaptureDate] = useState(null);
  const [captureTime, setCaptureTime] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [driverMobile, setDriverMobile] = useState("");
  const [intentDetails, setIntentDetails] = useState("");
  const [shareId, setShareId] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);
  const [popUpMessages, setPopUpMessages] = useState("");
  const [plantLocation, setPlanLocation] = useState();
  const [vendorCode, setVendorCode] = useState("");
  const [checkButton, setCheckButton] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [tokenShared, setTokenShared] = useState("");
  const [cookies, setCookie] = useCookies(["user"]);
  const [apiStatus, setApiStatus] = useState("");
  const [shareStatus, setShareStatus] = useState("");
  const location = useLocation();
  const BASE_URL = "http://vgeccdev.vguard.in:8001";
  const navigate = useNavigate();

  const showIntentData = async () => {
    try {
      const getIntentData = await getIntentDetails(tokenShared);
     // console.log("getIntentData___", getIntentData);
      setDriverMobile(getIntentData.data.intentInfo?.supplier_mobile);
      setIntentDetails(getIntentData?.data?.intentInfo);
      setShareId(getIntentData?.data?.vendorInfo?.share_id);
      setPlanLocation(getIntentData?.data?.vendorInfo);
      setVendorCode(getIntentData?.data?.vendorInfo?.vendor_code);
      setShareStatus(getIntentData?.data?.vendorInfo?.share_status);
      const gateStatus = getIntentData?.data?.vendorInfo?.share_status;
      if (gateStatus === "Completed") {
        setErrorAlert(true);

        const errorMessage = "Link expired";
        setPopUpMessages(errorMessage);

        return;
      } else {
        // Else check gate status and navigate
        const targetRoute =
          gateStatus == "Gate-In"
            ? RouteConstant?.GATE_OUT
            : RouteConstant?.GATE_IN;

        navigate(targetRoute);
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 400) {
        setErrorAlert(true);
       // console.log("error___", error);
        const errorMessage = "something went wrong";
        setPopUpMessages(errorMessage);
      } else {
        // setAlertMessage(loginContent.somethingWrong);
        // setShowAlert(true);
      }
    }
  };

  const stationLocation = {
    lat: plantLocation?.vendor_latitude,
    lon: plantLocation?.vendor_longitude,
  };

  // The below uses current location

  useEffect(() => {
    // Fetch the user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // console.log('currentLocation___', currentLocation)
          setCurrentLocation({ lat: latitude, lon: longitude });
        },
        (error) => {
          console.error("Error fetching location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    // // Use dummy data instead of fetching real location
    // const dummyLocationWithinRadius = { lat: 10.0042750, lon: 76.3756549 }; // Within 250 meters
    // const dummyLocationOutsideRadius = { lat: 12.97, lon: 77.59 }; // Outside 250 meters
    // setCurrentLocation(dummyLocationWithinRadius);
    const path = window.location.href; // Get full URL

    const match = path.match(/token\/([^/]+)/); // Extract token after 'token/'

    const ShareToken = match ? match[1] : null;

    setCookie("Share-Token", ShareToken, { path: "/" });
    setTokenShared(ShareToken);
    showIntentData();
  }, []);

  useEffect(() => {
    // Check if the current location is within 250 meters of the station location
    if (currentLocation) {
      const distance = calculateDistance(
        currentLocation.lat,
        currentLocation.lon,
        stationLocation.lat,
        stationLocation.lon
      );
      setIsButtonEnabled(true);
      // if (distance <=  250) {
      //   setIsButtonEnabled(true);
      // } else {
      //   setIsButtonEnabled(false);
      // }
    }
  }, [currentLocation]);

  const gateInData = (payload) => {
    return Axioscall.post("/zgate_api/ZGATE", payload, {
      headers: {
        "content-type": "application/json",
      },
    });
  };

  const details = [
    { heading: "Freight Order No", data: intentDetails.sap_id },
    { heading: "Source Name", data: intentDetails.source_name },
    { heading: "Source City", data: intentDetails.source_city },
    { heading: "Transporter Name", data: intentDetails.supplier_name },
  ];

  const gateinDetails = {
    freight_order_no: intentDetails?.sap_id,
    Indicator_in: "X", //Gate In indicator

    Vehicle_No: vehicleNumber,
    Gate_In_at_Source_date: moment(captureDate).format("YYYY-MM-DD"),
    Gate_In_at_Source_time: captureTime,
    Driver_Mobile_No: driverMobile,
    vendor_code: vendorCode,
    Gate_Entry_No: "",
    LR_Details: "",
    VEHICLE_INSURANCE: "",
    Fitness_Certificate: "",
    Pollution_Certificate: "",
    Driver_License_Validity: "",
    Vehicle_Permit: "",
    Remarks: "",
    Pickup: "",
    Dropoff: "",
    share_id: shareId,
    latitude: currentLocation?.lat,
    longitude: currentLocation?.lon,
  };

  const Axioscall = axios.create({
    baseURL: BASE_URL,
  });

  const submitGateInData = async (gateinDetails) => {
    setApiStatus("fetching");

    // CHECK INTENT STATUS FIRST
    // ---------------------------------
    if (shareStatus === "Completed") {
      setErrorAlert(true);
      setPopUpMessages("Link expired");
      setApiStatus("completed");
      return;
    }
    try {
      const response = await gateInOut(gateinDetails);

      if (response?.data?.statusCode == 200) {
        const successMessage = response?.data?.statusMessage;
        setSuccessAlert(true);
        setPopUpMessages(successMessage);
        //navigate(RouteConstant.GATE_OUT);
      }
    } catch (error) {
      if (
        error?.response?.data?.statusCode === 400 ||
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 422
      ) {
        const errorMessage = error.response.data.statusMessage;
        setErrorAlert(true);
        setPopUpMessages(errorMessage);
      }
    }
    setApiStatus("completed");
  };

  const onChangeVehicleNumber = (value) => {
    const capitalizedValue = value.toUpperCase();
    setErrorMsg("");
    setVehicleNumber(capitalizedValue);
  };
  const naviagteToGateOut = () => {
    navigate(RouteConstant.GATE_OUT);
  };
  const handleCapturedImage = (image) => {
    setCapturedImage(image);

    const now = new Date();
    setCaptureDate(now.toLocaleDateString()); // Format: MM/DD/YYYY
    setCaptureTime(now.toLocaleTimeString()); // Format: HH:MM:SS AM/PM
  };

  const onSubmitGateIn = () => {
    let hasError = false;

    if (!vehicleNumber.trim()) {
      setErrorMsg(ContentData.gateInOutPage.enterField);
      hasError = true;
    } else {
      setErrorMsg("");
    }

    if (!captureDate || !captureTime) {
      setImageErrorMsg(ContentData.gateInOutPage.takePic);
      hasError = true;
    } else {
      setImageErrorMsg(null);
    }

    if (hasError) {
      return;
    }

    // Gate In Data Send
    submitGateInData(gateinDetails);
  };

  useEffect(() => {
    if (location.pathname !== RouteConstant.GATE_IN) return;
    window.history.pushState(null, null, window.location.href);

    const handlePopState = () => {
      navigate(1); // Block back
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname]);

  // useEffect(()=>{
  //   if (!vehicleNumber.trim()) {
  //     setCheckButton(false)
  //   }
  // },[checkButton])

  const providerValue = {
    vehicleNumber,
    onChangeVehicleNumber,
    onSubmitGateIn,
    errorMsg,
    capturedImage,
    handleCapturedImage,
    isButtonEnabled,
    imageErrorMsg,
    details,
    popUpMessages,
    errorAlert,
    setErrorAlert,
    successAlert,
    setSuccessAlert,
    successMessage,
    setSuccessMessage,
    naviagteToGateOut,
    apiStatus,
    shareStatus,
    setShareStatus,
  };

  return (
    <GateInContext.Provider value={providerValue}>
      {children}
    </GateInContext.Provider>
  );
};
